"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapPageElement = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _PrismicPreviewWrapper = _interopRequireDefault(require("./PrismicPreviewWrapper"));

var wrapPageElement = function wrapPageElement(_ref, options) {
  var element = _ref.element,
      props = _ref.props;
  return _react.default.createElement(_PrismicPreviewWrapper.default, (0, _extends2.default)({}, props, {
    repositoryName: options.repositoryName
  }), element);
};

exports.wrapPageElement = wrapPageElement;